import React, { useState } from 'react';
// import AgoraUIKit from 'agora-react-uikit';
import { Box, Button, CircularProgress } from '@mui/material';
import LeadService from '../../../core/services/leadsService';
import toast from 'react-hot-toast';
import CallIcon from '@mui/icons-material/Call';
import VideocamIcon from '@mui/icons-material/Videocam';
const VideoAudioCall = ({ lead_id, caller_id, receiver_ids }) => {
    const [callType, setCallType] = useState(null); // null, 'audio', or 'video'
    const [inCall, setInCall] = useState(false);
    const [responseCall, setResponseCall] = useState(null); // Initially set to null

    const rtcProps = {
        appId: 'c11ae49557004e32b699170b470bcfa7',
        channel: responseCall?.channel_name || 'default-channel', // Use a default channel if responseCall is null
        token: "responseCall?.token || null", // Use the token from your API
        video: callType === 'video', // Enable video only if 'video' is selected
        audio: true
    };

    const callbacks = {
        EndCall: () => setInCall(false),
    };

    const startCall = async (type) => {
        setCallType(type);
        setInCall(true);

        try {
            const callTypeApi = type === "audio" ? "voice" : type;
            const leadId = String(lead_id);
            const res = await LeadService.initiateGroupCall(
                callTypeApi,
                leadId,
                caller_id,
                receiver_ids
            );

            if (res?.data?.success) {
                setResponseCall(res.data.call); // Set the response call object
            } else {
                toast.error('Failed to initiate call');
                setInCall(false);
            }
        } catch (error) {
            toast.error(error.message);
            setInCall(false);
        }
    };

    const buttonStyle = {
        margin: '10px', // Adjust spacing between buttons
        padding: '10px 20px', // Button padding
    }

    return (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            {!inCall ? (
                <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , }}>
                    {/* <Button
                        variant="contained"
                        color="primary"
                        onClick={() => startCall('audio')}
                        startIcon={<CallIcon />}
                        style={{ ...buttonStyle, backgroundColor: '#2196F3', color: '#fff', borderRadius:'18px'}} // Blue color for audio call
                    >
                        Audio Call
                    </Button> */}

                    {/* <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => startCall('video')}
                        startIcon={<VideocamIcon />}
                        style={{ ...buttonStyle, backgroundColor: '#f44336', color: '#fff',borderRadius:'18px' }} // Red color for video call
                    >
                        Video Call
                    </Button> */}
                </Box>
            ) : (
                responseCall ? ( // Check if responseCall is available
                    <div style={{ display: 'flex', width: '100vw', height: '100vh' }}>
                        {/* <AgoraUIKit
                            rtcProps={rtcProps}
                            callbacks={callbacks}
                            styleProps={{
                                localBtnContainer: {
                                    mute: { display: 'block' },
                                    camera: { display: callType === 'video' ? 'block' : 'none' },
                                },
                            }}
                        /> */}
                    </div>
                ) : (
                    <CircularProgress /> // Show a loading spinner while waiting for the response
                )
            )}
        </div>
    );
};

const buttonStyle = {
    padding: '10px 10px',
    fontSize: '10px',
    margin: '5px',
    cursor: 'pointer',
    width: 'auto',
    borderRadius: '22px',
};

export default VideoAudioCall;
